function preloadImages(noTrials)
{
  var preloadTime = (new Date()).getTime();
  var hasAnyCFTPTrial = false;
  var t0 = performance.now();

  for (var i = 1; i < 13; i++)
  {
    buttonsContainers[i] = document.getElementById('button'+i);
  }
  //define stim containers
  
  // we need to reset this so we don't affect the tmp reference we are making for navigation in preview (required for videos/audios)
  if (window.inPreviewMode) {
    stimContainers = [];
  }

  stimContainers[0] = document.getElementById("imageTarget");
  for (var i = 1; i <= window.stimFieldsMax; i++)
  {
    stimContainers[i] = document.getElementById('image'+i);
  }
  maskContainer = document.getElementById("mask");

  trialTextContainer = document.getElementById("trialText");

  // create table to preload images; invisible by default

  // in preview mode we rerun this and no we need to make sure we only have one tablePics
  if (window.inPreviewMode && $(".tablePics").length) {
    $(".tablePics").remove();  
  }

  var preloadPicsContainer = document.createElement("div");
  preloadPicsContainer.id = 'tablePics' + (window.inPreviewMode ? window.goToTrial.counter : '');
  preloadPicsContainer.classList.add('tablePics');
  preloadPicsContainer.style.display = 'none';

  var stimFormatIndex = getAllCollumnsIndexOf('stimFormat');
  window.imgs = {}; //unique list of image objects indexed by src
  var emptyImage = new Image();
  window.startPreloadTime = Date.now();

  console.log('noTrials c', noTrials)

  for (var i = 0; i < noTrials; i++) {
    var stimListColumn = window.stimListValues[i];
    const stimActualColumn = window.columnForTrial('stim_actual', i);
    var currentStimActualStimuli = stimActualColumn !== "na" ? stimActualColumn.split(';') : "na";
    if (currentStimActualStimuli && currentStimActualStimuli != 'na') {
        stimListColumn = currentStimActualStimuli;
    }

    var stimListStimuli = ["na"];
    if (stimListColumn && stimListColumn != "na"){
      stimListStimuli = stimListStimuli.concat(stimListColumn);
    }

    const imageCount = window.imageColumns.length;

    for (var iImage = 0; iImage < imageCount; iImage++)//maximum possible images in one trial (8 = target+ 6 test + mask)
    {
      var currentStimName = "na";
      if (iImage === imageCount - 1) {
        currentStimName = columnForTrial('mask', i);
      } else if (iImage === 0) {
        currentStimName = columnForTrial('target', i);
      } else {
        if (!stimListStimuli || stimListColumn === "na") {
          currentStimName = columnForTrial(imageColumns[iImage], i);
        } else if (stimListStimuli && stimListColumn != 'na' && stimListStimuli[iImage]) {
          currentStimName = stimListStimuli[iImage];
        }
      }

      let dynamicStim = currentStimName.indexOf('%') >= 0 ? true : false;

      //only for image stim
      if (!dynamicStim && columnForTrial('stimFormat', i) !== "survey" && columnForTrial('stimFormat', i) !== "word" && currentStimName!=="na" && (isTrialOfType(i, "image") || iImage === 0))
      {
        // if the extension is already in the stim name, don't append what we have in stimFormat
        const extension = currentStimName.endsWith(listArrays[stimFormatIndex][i]) || isTrialFromList(i) ? '' : listArrays[stimFormatIndex][i];
        var src = window.locationStim + currentStimName + extension + '?ts=' + startPreloadTime; //bust cache
        // create only first time we encounter it
        if (!imgs[src]) {
          var img = document.createElement('img');
          img.id = preloadImgId(iImage, i);
          img.src = src;
          img.alt = "";
          preloadPicsContainer.appendChild(img);
          imgs[src] = img;
        }

        console.info('set images');
        images[iImage][i] = imgs[src];
        if(currentStimName.indexOf('.') >= 0) {
          currentStimName = currentStimName.split('.')[0];
        }
        images[iImage][i].dataset.stimName = currentStimName;
      } else {
        // necesarry for some old code. Change this as we do not need some many objects.
         images[iImage][i] = emptyImage;
      }


      if (dynamicStim) {
        let img = {};
        img.type = "dynamic"
        img.text = currentStimName;
        img.src = "";

        images[iImage][i] = img;
      }
    }

    if (columnForTrial('test', i) == 'CFPT') {
      hasAnyCFTPTrial = true;
    }

    // var currentStimActualStimuli = window.columnForTrial('stim_actual', i);
    // if(currentStimActualStimuli !== "na") {
    //   preloadStimuliArray(preloadPicsContainer, currentStimActualStimuli.split(';'));
    // }
  }

  var backgroundStimuli = window.trialData.backgroundStimuli;
  if(backgroundStimuli){
    preloadStimuliArray(preloadPicsContainer, backgroundStimuli, backgroundImageOnLoadCallback);
  }

  // preload consent if required
  // if (screen_consent == "on" || screen_consent == "1") {
  //   consentImage = new Image();
  //   consentImage.src = locationConsent + "consent.jpg?" + preloadTime ;
  //   img = document.createElement('img');
  //   img.id = 'preConsent';
  //   img.src = consentImage.src;
  //   preloadPicsContainer.appendChild(img);
  // }

  if (hasAnyCFTPTrial) {
    img = document.createElement('img');
    img.src = '../../../assets/misc/arrowLeft.png';
    preloadPicsContainer.appendChild(img);

    img = document.createElement('img');
    img.src = '../../../assets/misc/arrowRight.png';
    preloadPicsContainer.appendChild(img);
  }

  document.body.appendChild(preloadPicsContainer);
  const x = window.inPreviewMode ? window.goToTrial.counter : -100;
  const failedImages = [];

  // first thing to show on page after images are preloaded!!!!!
  $('#' + preloadPicsContainer.id).imagesLoaded()
    .always(function() {
      console.info('[imagesLoaded] images were loaded now');
    })
    .done(function() {
      console.info('[imagesLoaded] images were successfully loaded');
      
      if (window.inPreviewMode &&  x !== window.goToTrial.counter) {
          console.log('[imagesLoaded] nothing to do here');
        // this is loaded for a past call, nothing to do
        return
      }
      onPrepareDone('imagesPreload');
    })
    .progress(function(instance, image) {
        !image.isLoaded && failedImages.push(image.img.src.split('/').pop().split('?')[0]);
        // console.log( '[imagesLoaded] image is ' + result + ' for ' + image.img.src, image.img.complete, image.img.naturalHeight );
    })
    .fail(function() {
      console.log('[imagesLoaded] fail');      
      if (failedImages.length) {
        displayText("content", "Failed to preload: <pre style='display:inline'>" + failedImages.join(', ') + "</pre>.");
      }
      displayText("title", "Experiment did not load properly. Please try again.");
      // close the loader to be able to see the message
      QueryLoader.doneLoad();
    });

  //add eventListeners
  for (var i = 1; i <= window.stimFieldsMax; i++) {
      $(stimContainers[i]).on('click', (function(il) {
                                          return function(e) {
                                                  clickStim(e, this, il)
                                                };
                                        })(i));
  }

  var t1 = performance.now();
  console.log("Call to preloadImages took " + (t1 - t0) + " milliseconds.");
}
function onPrepareDone(prepareSection) {
    onPrepareDone.expectedDone[prepareSection] = true;
    console.log('section' + prepareSection + ' is done');

    // refresh rate is not needed in preview mode
    if (!window.inPreviewMode) {
      if (onPrepareDone.expectedDone.imagesPreload && onPrepareDone.expectedDone.mediaPreload && onPrepareDone.expectedDone.setup && !onPrepareDone.expectedDone.frameRate) {
        determineRefreshRate();
        return;
      }
    }

    if (onPrepareDone.expectedDone.imagesPreload && onPrepareDone.expectedDone.mediaPreload && onPrepareDone.expectedDone.setup && onPrepareDone.expectedDone.frameRate) {
      onAllLoad();
    }
}

function resetPreparedDone() {
  window.onPrepareDone.expectedDone = {
    imagesPreload: false,
    mediaPreload: false,
    setup: false,
    frameRate: false,
  };

  if (window.inPreviewMode) {
    // refresh rate is not needed in preview mode
    window.onPrepareDone.expectedDone.frameRate = true;
  }
}
resetPreparedDone();

function onAllLoad() {
  if (window.inPreviewMode) {
    QueryLoader.doneLoadNow();
  } else {
    QueryLoader.doneLoad();
  }
  
  // need to reset status if in preview mode as we have multiple calls
  if (window.inPreviewMode) {
    resetPreparedDone();
  }

  if (bgColor_setup == "na") {bgColor_setup = bgColor_default;}
  if (textColor_setup == "na") {textColor_setup = textColor_default;}
  if (textSize_setup == "na") {textSize_setup = textSize_default;}

  console.info('it took ' + (performance.now() - window.begin) + 'ms');
  console.log('calling main');

  if (!window.onAllLoadCb) {
    main();
  } else {
      window.onAllLoadCb();
  }
}

function preloadImgId(iImage, trialNo) {
  return "pre"+ imageColumns[iImage] + '_' + trialNo;
}

function preloadStimuliArray(preloadPicsContainer, stimuli, onLoadCallback) {
  if(stimuli[0]) {
    const stimSplit = stimuli[0].split('.');
    const stimFormat = '.' + stimSplit[stimSplit.length-1];
    if(window.imageFormats.indexOf(stimFormat) < 0) {
      return;
    }
  } else {
    return;
  }

  for (var i = 0; i < stimuli.length; i++) {
    var src = window.locationStim + stimuli[i] + '?ts=' + startPreloadTime;
    if (!window.imgs[src]) {
      var img = document.createElement('img');
      img.id = "pre" + stimuli[i];
      img.src = src;
      preloadPicsContainer.appendChild(img);
      window.imgs[src] = img;
      if(onLoadCallback) {
        onLoadCallback(img, stimuli[i]);
      }
    }
  }
}

function backgroundImageOnLoadCallback(imageElement, imagePath) {
  //save bg image sizes on load to use them later
  $(imageElement).on('load',{image: imagePath}, function(event){
    window.listBackgroundSizes[event.data.image] = {
      width: event.currentTarget.width,
      height: event.currentTarget.height
    };
  })
}

function setupResponseBoxesButtons() {
  //define buttons containers at the start
  buttonsContainers[0] = document.getElementById('responseBox');
  labelBox =  document.getElementById('labelBox');

  window.responseBoxes = [];
  window.responseBoxesLabels = [];

  responseBoxes.push(buttonsContainers[0]);
  responseBoxesLabels.push(labelBox);

  var responseBoxParentNode = buttonsContainers[0].parentNode;
  for (var i = 2; i <= countMaxInputBoxes(); i++) {
    var currentResponseBoxLabel = document.getElementById('labelBox' + i);
    var currentResponseBox = document.getElementById('responseBox' + i);

    if(currentResponseBox == null){
      currentResponseBox = buttonsContainers[0].cloneNode(false);
      console.log('responseBox', currentResponseBox);
      currentResponseBox.setAttribute("onkeydown", "");
      console.log('responseBox', currentResponseBox);
      currentResponseBox.id += i;
      responseBoxParentNode.appendChild(currentResponseBox);
    }

    if(currentResponseBoxLabel == null){
      currentResponseBoxLabel = labelBox.cloneNode(false);
      currentResponseBoxLabel.setAttribute("for", "responseBox" + i)
      currentResponseBoxLabel.id += i;
      responseBoxParentNode.appendChild(currentResponseBoxLabel);
    }

    responseBoxesLabels.push(currentResponseBoxLabel);
    responseBoxes.push(currentResponseBox);
  }    
}